import { render, staticRenderFns } from "./AddImovelPage.vue?vue&type=template&id=43013210&"
import script from "./AddImovelPage.vue?vue&type=script&lang=js&"
export * from "./AddImovelPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports